import React from "react";
import {Route, Routes} from "react-router-dom";
import CreateDangerEvaluation from "../container/dangerEvaluation/CreateDangerEvaluation";
import DangerEvaluationList from "../container/@DEPRECATED/DangerEvaluationList";
import UpdateDangerEvaluation from "../container/dangerEvaluation/UpdateDangerEvaluation";
import ConfigureDangerEvaluation from "../container/dangerEvaluation/ConfigureDangerEvaluation";
import CheckItemList from "../container/dangerEvaluation/CheckItemList";
import UpdateCheckItem from "../container/dangerEvaluation/UpdateCheckItem";
import CreateCheckItem from "../container/dangerEvaluation/CreateCheckItem";
import DangerEvaluationCheckPermission from "../container/dangerEvaluation/DangerEvaluationCheckPermission";
import {useRecoilValue} from "recoil";
import {levelSelector} from "../Recoil/Atom/authState";
import NotFound from "./NotFound";
import EvaluationMasterList from "../container/evalutaionMaster/EvaluationMasterList";
import CreateEvaluationMaster from "../container/evalutaionMaster/CreateEvaluationMaster";
import EvaluationRevisionList from "../container/evalutaionMaster/EvaluationRevisionList";
import CreateRevision from "../container/@DEPRECATED/CreateRevision";
import UpdateEvaluationMaster from "../container/evalutaionMaster/UpdateEvaluationMaster";

const Permission = () => {
  const userLevel = useRecoilValue(levelSelector);

  return (
    <Routes>
      {userLevel === 3 ? (
        <Route>
          <Route path="Configure" element={<ConfigureDangerEvaluation />} />
          <Route path="CheckItemList/:id" element={<CheckItemList />} />
          <Route path="CreateCheckItem/:id" element={<CreateCheckItem />} />
          <Route path="EditCheckItem/:id" element={<UpdateCheckItem />} />
        </Route>
      ) : (
        <Route path="*" element={<NotFound />} />
      )}

      {userLevel === 4 ? (
        <Route>
          {/* <Route path="List" element={<DangerEvaluationList />} /> */}
          <Route path="List" element={<EvaluationMasterList />} />
          <Route path="Create/:id" element={<CreateDangerEvaluation />} />
          <Route path="Edit/:id" element={<UpdateDangerEvaluation />} />
          <Route path="RevisionList/:id" element={<EvaluationRevisionList />} />
          <Route path="CreateMaster" element={<CreateEvaluationMaster />} />
          <Route path="EditMaster/:id" element={<UpdateEvaluationMaster />} />
          <Route path="CheckPermission/:id" element={<DangerEvaluationCheckPermission />} />
        </Route>
      ) : (
        <Route path="*" element={<NotFound />} />
      )}
    </Routes>
  );
};

export default Permission;
